// extracted by mini-css-extract-plugin
module.exports = {"box":"content-module--box--2WpBA"};